import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-manage-taskcategory',
  templateUrl: './manage-taskcategory.component.html',
  styleUrls: ['./manage-taskcategory.component.scss']
})

export class ManageTaskCategoryComponent implements OnInit {

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList: [],
    officeID: 0
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  taskCategoryList: any[] = [];
  value = '';
  paginatorTotalLength: any;
  dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any = [];
  myOfficeID: any;
  ShowNoRecordFound: boolean = false;
  spinner: boolean = false;
  tasktemplateCategoryID: number = 0;
  databaseId: string;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    this.getTaskCategoryList();
  }

  
  getTaskCategoryList() {
    this.loaderService.show();
    var ReqModel = {
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.taskCategoryList = this.responseHolder.data;
          if (this.taskCategoryList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.taskCategoryList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound = true;
        this.taskCategoryList = [];
        this.loaderService.hide();
      }
    });
  }


  openDialogAddWithRef(templateRef: TemplateRef<any>) {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('categoryName', this.formBuilder.control(''));
    this.dialog.open(templateRef);
  }



  AddTaskCategory(data) {
    let ReqModel = {
      categoryName: data.categoryName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.spinner = true;
    this.formDialog.markAsPristine();
    this.settingsService.addTaskTemplateCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.dialog.closeAll();
          this.toastr.success('Task category added successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskCategoryList();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }


  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    let group = {};
    this.updateformDialog = new FormGroup(group);
    this.tasktemplateCategoryID = task.taskTemplateCategoryID;
    this.updateformDialog.addControl('categoryName', this.formBuilder.control(''));

    this.updateformDialog.controls['categoryName'].setValue(task.taskTemplateCategoryName);

    this.dialog.open(templateRef);
    this.updateformDialog.markAsPristine();
  }


  UpdateTaskCategory(data) {
    let ReqModel = {
      tasktemplateCategoryID: this.tasktemplateCategoryID,
      taskTemplateCategoryName: data.categoryName,
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.spinner = true;
    this.updateformDialog.markAsPristine();
    this.settingsService.renameTaskTemplateCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.dialog.closeAll();
          this.toastr.success('Task category update successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskCategoryList();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.error('Task category update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.spinner = false;
        this.loaderService.hide();
        this.toastr.error('Task status update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }





  UpdateStatusToggle(task: any, event: any) {
    this.loaderService.show();
    var ReqModel = {
      tasktemplateCategoryID: task.taskTemplateCategoryID,
      activate: event.checked,
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
    }
    this.settingsService.activateTaskCategoryTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTaskCategoryList();
          this.loaderService.hide();
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
        } else {
          this.showOptionForDelete = false;
          this.selectedRecordDelete = [];
          this.loaderService.hide();
          this.toastr.error('Status update failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.showOptionForDelete = false;
        this.selectedRecordDelete = [];
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }



  //========== For Delete Record ==============//
  selectedRecordDelete: any = [] = [];
  showOptionForDelete: boolean = false;

  selectRecordForDelete(event, temp) {
    if (event.checked) {
      let ReqModel = {
        selectedRecord: temp.taskTemplateCategoryID
      };
      this.selectedRecordDelete.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDelete.findIndex((itm) => itm.selectedRecord === temp.taskTemplateCategoryID);
      if (removeIndex !== -1) this.selectedRecordDelete.splice(removeIndex, 1);
    }

    if (this.selectedRecordDelete.length > 0) {
      this.showOptionForDelete = true;
    }
    else {
      this.showOptionForDelete = false;
      this.selectedRecordDelete = [];
    }

  }


  deleteMultipleTaskCategory() {
    const message = `Are you sure you want to delete selected task category?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var selectedtasklist = [];
          if (this.selectedRecordDelete.length > 0) {
            for (var i = 0, len = this.selectedRecordDelete.length; i < len; ++i) {
              const taskTemplateCategoryID = this.selectedRecordDelete[i].selectedRecord;
              selectedtasklist.push(taskTemplateCategoryID);
            }
          }
          var reqModel = {
            tasktemplateCategoryIDs: selectedtasklist,
            userID: this.currentUser.UID,
            officeID: Number(this.myOfficeID),
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.settingsService.removeTaskTemplateCategories(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.success('Task category deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.getTaskCategoryList();
              } else {
                this.showOptionForDelete = false;
                this.selectedRecordDelete = [];
                this.loaderService.hide();
                this.toastr.error('Task category deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.showOptionForDelete = false;
              this.selectedRecordDelete = [];
              this.loaderService.hide();
              this.toastr.error('Task category deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  close() {
    this.formDialog.reset();
    this.dialog.closeAll();
  }

  closeUpdate() {
    this.updateformDialog.reset();
    this.dialog.closeAll();
  }

}
